import { ClassicEditor as ClassicEditorBase } from '@ckeditor/ckeditor5-editor-classic';
import { Essentials } from '@ckeditor/ckeditor5-essentials';

import { Autoformat } from '@ckeditor/ckeditor5-autoformat';
import { Alignment } from '@ckeditor/ckeditor5-alignment';
// All possible basic styles plugins: Bold,Code,Italic,Strikethrough,Subscript,Superscript,Underline
import { Bold, Italic, Underline, Strikethrough,Subscript,Superscript, } from '@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { FontFamily,FontSize,FontColor,FontBackgroundColor } from "@ckeditor/ckeditor5-font"
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Image, 
        ImageCaption,
        ImageStyle, ImageToolbar, ImageUpload, PictureEditing, ImageResize } from '@ckeditor/ckeditor5-image';
import { Indent } from '@ckeditor/ckeditor5-indent';
import { Link } from '@ckeditor/ckeditor5-link';
import { List } from '@ckeditor/ckeditor5-list';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { PasteFromOffice } from '@ckeditor/ckeditor5-paste-from-office';
import { Table, TableToolbar } from '@ckeditor/ckeditor5-table';
import { SimpleUploadAdapter } from '@ckeditor/ckeditor5-upload';
import { Base64UploadAdapter } from '@ckeditor/ckeditor5-upload';
import { Widget } from '@ckeditor/ckeditor5-widget';

export default class ClassicEditor extends ClassicEditorBase {
public static override builtinPlugins = [
    Essentials,
    Autoformat,
    Alignment,
    Bold,
    Base64UploadAdapter,
    FontFamily,FontSize,FontColor,FontBackgroundColor,
    Italic,
    Indent,
    ImageCaption,
    Image, ImageStyle, ImageResize, ImageToolbar, ImageUpload, PictureEditing,
    Underline,
    BlockQuote,
    Heading,
    Link,
    List,
    Paragraph,
    PasteFromOffice,
    SimpleUploadAdapter,
    Table, TableToolbar,
    Widget
] 
public static override defaultConfig = {
    toolbar: {
        items: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "bold",
            "italic",
            "underline",
            "|",
            "numberedList",
            "bulletedList",
            "|",
            "imageUpload",
            // "imageTextAlternative", removed with 5541
            // "toggleImageCaption",
            "|",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "alignment",
            "indent",
            "outdent",
            "|",
            "insertTable",
            "tableColumn", 
            "tableRow", 
            "mergeTableCells",
            // "resizeImage", /// Pin in it, get these working
            // "imageStyle:wrapText", /// Run this by eswars PDF generator. Put in text, add image inline. Shift text to left and right of image with ck and see if it comes out correctly on the other side
            // "imageStyle:breakText",
            ]
    },
    // Below is simple upload adapter. If base64 images prove to be too slow, we will need to use this.
    // simpleUpload: {
    //     // The URL that the images are uploaded to.
    //     uploadUrl: 'http://test.com',

    //     // Enable the XMLHttpRequest.withCredentials property.
    //     withCredentials: true,

    //     // Headers sent along with the XMLHttpRequest to the upload server.
    //     headers: {
    //         'X-CSRF-TOKEN': 'CSRF-Token',
    //         Authorization: 'Bearer <JSON Web Token>'
    //     }
    // },
    image: {
        toolbar: [ 'toggleImageCaption', 'imageTextAlternative', "resizeImage","imageStyle:wrapText","imageStyle:breakText", ]
    },
    language: "en"
    }
}